"use strict";

import flatpickr from "flatpickr";
import tippy, {followCursor, roundArrow} from "tippy.js";
import "tippy.js/dist/tippy.css";
import 'tippy.js/dist/svg-arrow.css';
import {Italian} from "flatpickr/dist/l10n/it";
import English from "flatpickr/dist/l10n/es";

export const singleProductDatePicker = (data) => {
    return ({
        open: false,
        datePickerElement: document.getElementById('singleProductDatePicker'),
        invalidDatesFromRequest: data.invalidDatesFromRequest,
        datePicker: null,
        checkIn: data.checkIn,
        checkOut: data.checkOut,
        minStayErrorString: data.minStayErrorString,
        minStayNoticeString: data.minStayNoticeString,
        notAllowedEndDayNotice: data.notAllowedEndDayNotice,
        startDateInput: document.querySelector('.date__start-date'),
        endDateInput: document.querySelector('.date__end-date'),
        // lockedDays: JSON.parse(data.lockedDays),
        lockedDaysForCheckIn: JSON.parse(data.lockedDaysForCheckIn),
        lockedDaysForCheckOut: JSON.parse(data.lockedDaysForCheckOut),
        lockedStartDays: JSON.parse(data.lockedStartDays),
        lockedEndDays: JSON.parse(data.lockedEndDays),
        minimumStays: JSON.parse(data.minimumStays),
        defaultMinDaysStay: 1,
        currentMinDaysStay: 1,
        firstBlockedDay: null,
        checkInToShow: null,
        checkOutToShow: null,
        minStayUnit: data.minStayUnit,
        util: require('util'),
        currentLocale: data.currentLocale,
        currentDateLocale: null,
        dateFormat: {
            month: 'short',
            day: 'numeric',
            year: '2-digit'
        },
        toLocaleString(date) {
            return date?.toLocaleDateString("it-IT", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            }) ?? ''
        },
        close() {
            this.open = false;
        },
        dispatch(days) {
            window.dispatchEvent(new CustomEvent('nights-change', {
                detail: {
                    value: days,
                }
            }))
        },
        init() {
            if (this.open) {
                this.onShowDatePicker();
            }
            this.minimumStays.map(item => {
                item['from'] = new Date(item['from']);
                item['to'] = new Date(item['to']);
                return item;
            })
            this.lockedDaysForCheckIn = this.castToArray(this.lockedDaysForCheckIn);
            this.lockedDaysForCheckOut = this.castToArray(this.lockedDaysForCheckOut);
            this.lockedStartDays = this.castToArray(this.lockedStartDays);
            this.lockedEndDays = this.castToArray(this.lockedEndDays);
            window.addEventListener('load', () => {
                this.setStartDateInput();
                this.setEndDateInput();
            });
            this.currentDateLocale = this.currentLocale === 'it' ? 'it-IT' : 'en-EN';
            if (this.checkIn) {
                this.checkInToShow = new Date(this.checkIn).toLocaleDateString(this.currentDateLocale, this.dateFormat);
            }
            if (this.checkOut) {
                this.checkOutToShow = new Date(this.checkOut).toLocaleDateString(this.currentDateLocale, this.dateFormat)
            }
        },
        setStartDateInput() {
            if (typeof this.checkIn === 'string') {
                this.checkIn = new Date(this.checkIn);
            }
            this.startDateInput.value = this.checkIn !== null ? this.checkIn.toLocaleString('sv-SE', this.dateFormat) : '';
            this.startDateInput.dispatchEvent(new Event("change", {bubbles: true}));
        },

        setEndDateInput() {
            if (typeof this.checkOut === 'string') {
                this.checkOut = new Date(this.checkOut);
            }
            this.endDateInput.value = this.checkOut !== null ? this.checkOut.toLocaleString('sv-SE', this.dateFormat) : '';
            this.endDateInput.dispatchEvent(new Event("change", {bubbles: true}));
        },
        castToArray(value) {
            if (value === null) {
                return [];
            }
            return Array.isArray(value)
                ? value
                : (typeof value === 'object')
                    ? Object.values(value)
                    : [];
        },

        reset() {
            this.currentMinDaysStay = this.defaultMinDaysStay;
            this.datePicker.clear();
            this.firstBlockedDay = null;
            this.checkIn = null;
            this.checkOut = null;
            this.checkInToShow = null;
            this.checkOutToShow = null;
            this.setStartDateInput();
            this.setEndDateInput();
        },
        getMinDaysStayFor(startDate) {
            let minDaysStay = this.defaultMinDaysStay;
            for (let minStay of this.minimumStays) {
                if (startDate >= minStay.from && startDate <= minStay.to) {
                    minDaysStay = Math.max(minDaysStay, minStay.days);
                }
            }
            if (this.currentMinDaysStay < minDaysStay) {
                this.currentMinDaysStay = minDaysStay;
            }
            return minDaysStay;
        },
        preventClick(event) {
            event.preventDefault();
            event.stopPropagation();
        },
        onShowDatePicker() {
            this.invalidDatesFromRequest = false;
            if (this.datePicker === null) {
                this.datePicker = flatpickr(this.datePickerElement, {
                    inline: true,
                    disableMobile: true,
                    locale: this.currentLocale === 'it' ? Italian : English,
                    mode: 'range',
                    showMonths: window.innerWidth >= 768 ? 2 : 1,
                    dayIncrement: 2,
                    minDate: new Date().fp_incr(1),
                    dateFormat: "Y-m-d",
                    defaultDate: [this.checkIn, this.checkOut],
                    disable: [
                        (date) => {
                            const from = this.datePicker?.selectedDates[0] ?? null;
                            const to = this.datePicker?.selectedDates[1] ?? null;
                            const dateString = date.toLocaleDateString('en-CA');

                            if ((from !== null && to !== null) || (from === null && to === null)) {
                                return [...new Set([...this.lockedDaysForCheckIn, ...this.lockedStartDays])].includes(dateString);
                            }
                            return date < from;

                        }
                    ],
                    onReady: (selectedDates, dateStr, instance) => {
                        this.datePicker = instance;
                    },
                    localeDateStringFormat: {
                        month: 'short',
                        day: 'numeric',
                        year: '2-digit'
                    },
                    onClose: (selectedDates, dateStr, instance) => {
                        if (selectedDates.length === 2) {
                            const minDaysStay = this.getMinDaysStayFor(selectedDates[0]);
                            const diffInDays = (selectedDates[1] - selectedDates[0]) / (1000 * 60 * 60 * 24);
                            if (diffInDays < minDaysStay) {
                                instance.clear();
                                this.currentMinDaysStay = this.defaultMinDaysStay;
                                alert(this.util.format(this.minStayErrorString, minDaysStay));
                            } else {
                                this.dispatch(diffInDays);
                            }
                        }
                    },
                    onDayCreate: (selectedDate, date, dayConfig, day) => {
                        day.classList.remove('blocked__by__min_stay_days', 'blocked__by__not_allowed_end_days', 'blocked__by__first_blocked_day',);
                        day.removeEventListener('click', this.preventClick);

                        const lockedDays = selectedDate.length === 0 ? this.lockedDaysForCheckIn : this.lockedDaysForCheckOut;

                        if (day.dateObj > selectedDate[0] && [...new Set([...lockedDays, ...this.lockedEndDays])].includes(day.dateObj.toLocaleDateString('en-CA'))) {
                            if (this.firstBlockedDay === null && lockedDays.includes(day.dateObj.toLocaleDateString('en-CA'))) {
                                this.firstBlockedDay = day.dateObj;
                                day.classList.add('blocked__by__first_blocked_day');
                            }
                            day.classList.add('blocked__by__not_allowed_end_days');

                            tippy(day, {
                                plugins: [followCursor],
                                content: this.notAllowedEndDayNotice,
                                followCursor: true,
                                animation: 'shift-away',
                                theme: 'buenaonda',
                                arrow: false,
                            });
                            day.addEventListener('click', this.preventClick);
                        }

                        if (selectedDate.length === 1) {
                            /**
                             * Impedisco all'utente di scegliere una data di chiusura successiva o uguale alla data
                             * del primo giorno bloccato
                             */
                            if (this.firstBlockedDay !== null && day.dateObj >= this.firstBlockedDay) {
                                day.classList.add('blocked__by__not_allowed_end_days');
                                day.classList.add('blocked__by__day_after_first_blocked_day');
                                tippy(day, {
                                    plugins: [followCursor],
                                    content: this.notAllowedEndDayNotice,
                                    followCursor: true,
                                    animation: 'shift-away',
                                    theme: 'buenaonda',
                                    arrow: false,
                                });
                                day.addEventListener('click', this.preventClick);
                            }

                            const diffInDays = (day.dateObj - selectedDate[0]) / (1000 * 60 * 60 * 24);
                            if (diffInDays > 0 && diffInDays < this.getMinDaysStayFor(selectedDate[0])) {
                                day.classList.add('blocked__by__min_stay_days');
                                day.addEventListener('click', this.preventClick);
                            }
                        }
                    },
                    onChange: (selectedDates, dateStr, instance) => {
                        if (selectedDates.length > 0) {
                            this.checkIn = selectedDates[0].toLocaleDateString('en-US', this.dateFormat)
                            this.checkInToShow = selectedDates[0].toLocaleDateString(this.currentDateLocale, this.dateFormat);
                            this.setStartDateInput();
                        }
                        if (selectedDates.length > 1) {
                            this.checkOut = selectedDates[1].toLocaleDateString('en-US', this.dateFormat);
                            this.checkOutToShow = selectedDates[1].toLocaleDateString(this.currentDateLocale, this.dateFormat)
                            this.setEndDateInput();
                            this.close();
                        }
                    }
                });
            }
        },
    });
};